import { useState } from 'react'

import { Avatar } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { generateAvatarColor, getContrastTextColor } from '@repo/shared'

export interface UserAvatarProps {
  src?: string
  nickname?: string
  size?: 'small' | 'default' | 'large' | number
}

function getInitial(nickname: string | undefined | null): string {
  if (!nickname || typeof nickname !== 'string') return '?'
  const trimmed = nickname.trim()
  if (trimmed.length === 0) return '?'
  const firstChar = trimmed[0]
  return firstChar ? firstChar.toUpperCase() : '?'
}

export function UserAvatar({ src, nickname, size = 'default' }: UserAvatarProps) {
  const [imageError, setImageError] = useState(false)

  const handleImageError = (): boolean => {
    setImageError(true)
    return false
  }

  const shouldShowImage = src && !imageError

  if (shouldShowImage) {
    return <Avatar src={src} size={size} onError={handleImageError} />
  }

  if (nickname) {
    const backgroundColor = generateAvatarColor(nickname)
    const textColor = getContrastTextColor(backgroundColor)
    return (
      <Avatar size={size} style={{ backgroundColor, color: textColor }}>
        {getInitial(nickname)}
      </Avatar>
    )
  }

  return <Avatar icon={<UserOutlined />} size={size} />
}
